<template>
  <BaseModal
    :activeModal="show"
    @closeModal="$emit('close')"
    :cancel="!recoveryCodes"
    :ok="!recoveryCodes"
    okLabel="aktywuj"
    @ok="enable"
    :close="!!recoveryCodes"
    :bgClose="!!recoveryCodes"
    size="md"
  >
    <template #header>
      Konfiguracja autoryzacji dwuetapowej
    </template>

    <template #default>
      <div class="mb-4 text-sm text-gray-600">
        Zeskanuj kod QR w aplikacji Google Authenticator,
        a następnie wpisz wygenerowany kod aby potwierdzić konfigurację.
      </div>

      <div class="mb-4 flex justify-center">
        <div
          v-if="isLoadingQr"
          class="w-40 h-40 bg-gray-200 flex items-center justify-center text-gray-500 text-xs"
        >
          Ładowanie QR...
        </div>

        <div
          v-else-if="qrCode"
          v-html="qrCode"
          class="w-40 h-40 flex items-center justify-center"
        />

        <div
          v-else
          class="w-40 h-40 bg-gray-200 flex items-center justify-center text-gray-500 text-xs"
        >
          Brak kodu QR
        </div>
      </div>

      <div class="mb-4">
        <label>kod z aplikacji</label>
        <input
          v-focus
          v-model="form.code"
          type="text"
          maxlength="6"
          @keyup.enter="enable"
          :class="{ 'border-red-300': error !== null }"
        >
        <div v-if="recoveryCodes" class="mb-4">
          <p class="text-sm font-semibold text-gray-600 my-2">
            Kody odzyskiwania
          </p>

          <div class="bg-gray-100 border rounded p-3 text-sm font-mono">
            <div
              v-for="(code, index) in recoveryCodes"
              :key="index"
              class="leading-6"
            >
              {{ code }}
            </div>
          </div>

          <button
            type="button"
            class="btn btn-secondary mt-3"
            @click="copyRecoveryCodes"
          >
            Skopiuj kody
          </button>
        </div>
      </div>

      <p v-if="error" class="text-red-500 text-sm">
        {{ error }}
      </p>
    </template>
  </BaseModal>
</template>

<script>
import TwoFactorService from '../services/TwoFactorService';

export default {
  name: 'UserTwoFactorSetup',
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      show: false,
      form: {
        code: '',
      },
      qrCode: null,
      isLoadingQr: true,
      error: null,
      recoveryCodes: null,
    };
  },
  mounted() {
    this.show = true;
    this.loadQrCode();
  },
  methods: {
    loadQrCode() {
      this.isLoadingQr = true;
      this.error = null;

      TwoFactorService.getQrCode()
        .then(response => {
          this.qrCode = response.data.svg;
          this.isLoadingQr = false;
        })
        .catch(() => {
          this.error = 'Nie udało się pobrać kodu QR';
          this.isLoadingQr = false;
        });
    },
    enable() {
      if (!this.form.code || this.form.code.length !== 6) {
        this.error = 'Nieprawidłowy kod';
        return;
      }

      this.isBusy = true;
      this.error = null;

      TwoFactorService.confirmTwoFactor({
        code: this.form.code,
      })
        .then(response => {
          this.recoveryCodes = response.data.recovery_codes || [];
          this.$emit('enabled');
        })
        .catch(() => {
          this.error = 'Nieprawidłowy kod';
        })
        .finally(() => {
          this.isBusy = false;
        });
    },
    copyRecoveryCodes() {
      if (!this.recoveryCodes) {
        return;
      }

      const text = this.recoveryCodes.join('\n');
      navigator.clipboard.writeText(text);
    },
  },
};
</script>
